import script from "./AddAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./AddAnnouncement.vue?vue&type=style&index=0&id=146c7bf8&lang=css"

const __exports__ = script;

export default __exports__